import axios from "axios";

import { sortedByKey } from "src/util/util.sortFilterOptions";
import { FULFILLED, PENDING, REJECTED } from "./action-type.util";

const ACTION_TYPES = {
  FETCH_OPTIONS: "brokers/FETCH_OPTIONS",
  FETCH_AFFILIATE: "brokers/FETCH_AFFILIATE",
  FETCH_BROKER_PRIMARY_EMAIL: "brokers/FETCH_BROKER_PRIMARY_EMAIL",
};

const initialState = {
  loading: false,
  companyAffiliate: undefined,
  isAfiliateRequestInProgress: false,
  brokerPrimaryEmailValidating: false,
  existentBrokerIdByEmail: undefined,
  affiliateList: [],
  branchList: [],
  companyList: [],
  selectStateList: [],
  rbmList: [],
  hearAboutUsList: [],
};

export type BrokerBuilderState = Readonly<typeof initialState>;

/**
 * BrokerBuilder Reducer
 */
export default (state: BrokerBuilderState = initialState, action): BrokerBuilderState => {
  switch (action.type) {
    case PENDING(ACTION_TYPES.FETCH_AFFILIATE): {
      return {
        ...state,
        companyAffiliate: undefined,
        loading: true,
        isAfiliateRequestInProgress: true,
      };
    }
    case PENDING(ACTION_TYPES.FETCH_OPTIONS): {
      return {
        ...state,
        companyAffiliate: undefined,
        loading: true,
      };
    }
    case PENDING(ACTION_TYPES.FETCH_BROKER_PRIMARY_EMAIL): {
      return {
        ...state,
        brokerPrimaryEmailValidating: true,
        existentBrokerIdByEmail: undefined,
      };
    }

    case FULFILLED(ACTION_TYPES.FETCH_OPTIONS): {
      const affiliateList = action.payload.data.selectAffiliateList.sort(sortedByKey);
      const branchList = action.payload.data.selectBranchList.sort(sortedByKey);
      const rbmList = action.payload.data.selectRBMList;
      const companyList = action.payload.data.selectCompanyList.sort(sortedByKey);
      const selectStateList = action.payload.data.selectStateList;
      const hearAboutUsList = action.payload.data.selectHearAboutUsList;

      return {
        ...state,
        companyAffiliate: undefined,
        affiliateList,
        companyList,
        branchList,
        rbmList,
        selectStateList,
        hearAboutUsList,
        loading: false,
      };
    }

    case FULFILLED(ACTION_TYPES.FETCH_AFFILIATE): {
      const companyAffiliate = action.payload.data;
      return {
        ...state,
        loading: false,
        companyAffiliate,
        isAfiliateRequestInProgress: false,
      };
    }

    case FULFILLED(ACTION_TYPES.FETCH_BROKER_PRIMARY_EMAIL): {
      const existentBroker = action.payload.data;

      return {
        ...state,
        brokerPrimaryEmailValidating: false,
        existentBrokerIdByEmail: existentBroker.brokerID,
      };
    }

    case REJECTED(ACTION_TYPES.FETCH_OPTIONS): {
      return {
        ...state,
        loading: false,
      };
    }

    case REJECTED(ACTION_TYPES.FETCH_BROKER_PRIMARY_EMAIL): {
      return {
        ...state,
        brokerPrimaryEmailValidating: false,
        existentBrokerIdByEmail: undefined,
      };
    }

    default: {
      return {
        ...state,
      };
    }
  }
};

export const fetchBrokerOptions = () => ({
  type: ACTION_TYPES.FETCH_OPTIONS,
  payload: axios.get("brokers/new"),
});

export const fetchCompanyAffiliate = (companyID: number) => ({
  type: ACTION_TYPES.FETCH_AFFILIATE,
  payload: axios.get(`companies/${companyID}/affiliate`),
});

export const fetchBrokerByPrimaryEmail = (brokerId: number, email: string) => ({
  type: ACTION_TYPES.FETCH_BROKER_PRIMARY_EMAIL,
  payload: axios.post(`validatePrimaryEmailExists`, { brokerId, email }),
});
